import { Capability } from '@mono/types/src/mds';

export const filterDirectionalCapabilities = ({ capabilities }: { capabilities: Capability[] }) => {
    return capabilities.filter((cap) => {
        const variables = Object.values(cap.variables);
        if (!variables || !variables[0]) return false;
        return variables.length === 1 && variables[0].units && variables[0].units === 'degree';
    });
};
